<template>
    <div>
        <!-- hide-timeout="1000" -->
        <el-dropdown ref="dropdown" placement="top-start" @visible-change="visibleChange" hide-on-click>
            <div class="your-organization">
                <slot name="button"></slot>
            </div>
            <el-dropdown-menu slot="dropdown" class="dropdown t-dropdown" >
                <div class="wrapper">
                    <el-row type="flex" :span="24" :gutter="10" justify="space-between">
                        <el-col :span="3.4">
                            <div class="col-title">Organisation</div>
                            <div class="col-content">
                                <!-- <div class="link" @click="routerLink('settings-dashboard')">Settings</div> -->
                                <div class="link" @click="routerLink('about')">Information</div>
                                <div class="link" @click="routerLink('settings-data-rooms')">Data Rooms</div>
                                <div class="link" @click="routerLink('settings-coa-view')">Chart of Accounts (CoA)</div>
                                <div class="link" @click="openWorkModal">Forecasts</div>
                                <div class="link" @click="openWorkModal">Business Centers</div>
                                <div class="link" @click="routerLink('business-units')">Business Units</div>
                                <div class="link" @click="openWorkModal">Performance</div>

                            </div>
                        </el-col>

                        <el-col :span="3.4">
                            <div class="col-title">Compliance</div>
                            <div class="col-content">
                                <div class="link" @click="openWorkModal">Statutory</div>
                                <div class="link" @click="openWorkModal">Regulatory</div>
                                <!-- <div class="link" @click="routerLink('taxation')">Taxation</div> -->
                                <div class="link" @click="routerLink('taxation-sales')">Taxation</div>
                                <!-- <div class="link" @click="routerLink('taxation-withholding')">Taxation Withholding</div> -->
                                <div class="link" @click="routerLink('source-documents')">Source Documents</div>
                            </div>
                        </el-col>
                        <el-col :span="3.4">
                            <div class="col-title">People & Culture (P&C)</div>
                            <div class="col-content">
                                <div class="link" @click="routerLink('users')">Team (Users)</div>
                                <div class="link" @click="openWorkModal">Acquiring</div>
                                <div class="link" @click="openWorkModal">Managing</div>
                                <div class="link" @click="openWorkModal">Optimising</div>
                                <div class="link" @click="openWorkModal">Timekeeping</div>
                                <div class="link" @click="routerLink('settings-leave-management')">Leave Management</div>
                                <div class="link" @click="routerLink('settings-payroll')">Payroll</div>
                            </div>
                        </el-col>
                        <el-col :span="3.4">
                            <div class="col-title">Supply Chain (SCM)</div>
                            <div class="col-content">
                                <div class="link" @click="openWorkModal">Selling</div>
                                <div class="link" @click="routerLink('vendors')">Vendors</div>
                                <div class="link" @click="routerLink('contacts-xero')">Contacts Xero</div>
                                <!-- <div class="link" @click="openWorkModal">Billers</div> -->
                                <!-- <div class="link" @click="routerLink('settings-items')">Items</div> -->
                                <div class="link" @click="openWorkModal">Items</div>
                                <div class="link" @click="routerLink('purchases')">Purchasing</div>
                                <div class="link" @click="openWorkModal">Spend Management</div>
                                <div class="link" @click="routerLink('warehousing')">Warehousing</div>
                                <div class="link" @click="openWorkModal">Logistics</div>
                            </div>
                        </el-col>
                        <el-col :span="3.4">
                            <div class="col-title">Customer Relationship (CRM)</div>
                            <div class="col-content">
                                <div class="link" @click="openWorkModal">Prospects</div>
                                <div class="link" @click="routerLink('clients')">Clients</div>
                                <div class="link" @click="openWorkModal">Billers</div>
                                <div class="link" @click="openWorkModal">Promotions</div>
                                <div class="link" @click="routerLink('engagements')">Engagements</div>
                                <div class="link" @click="routerLink('projects')">Projects</div>
<!--                                <div class="link" @click="routerLink('settings-items')">Items</div>-->
<!--                                <div class="link" @click="openWorkModal">Selling</div>-->
<!--                                <div class="link" @click="openWorkModal">Delivering</div>-->
                                <div class="link" @click="openWorkModal">Accounts Receivable</div>
                            </div>
                        </el-col>
                        <el-col :span="3.4">
                            <div class="col-title">Accounting</div>
                            <div class="col-content">
                                <div class="link" :class="{ disabled: !companyLayout.companyAccountingAndBusinessInfo }" @click="!companyLayout.companyAccountingAndBusinessInfo ? null : routerLink('journal-and-gl', { tab: 'journalReport' })">Journals (Books of First Entries)</div>
                                <div class="link" :class="{ disabled: !companyLayout.companyAccountingAndBusinessInfo }" @click="!companyLayout.companyAccountingAndBusinessInfo ? null : routerLink('general-ledger')">General Ledger (GL)</div>
                                <!-- <div class="link" :class="{ disabled: !companyLayout.companyAccountingAndBusinessInfo }" @click="!companyLayout.companyAccountingAndBusinessInfo ? null : openWorkModal">Cashflow Forecast</div> -->
                                <div class="link" :class="{ disabled: !companyLayout.companyAccountingAndBusinessInfo }" @click="!companyLayout.companyAccountingAndBusinessInfo ? null : openWorkModal">Revolving Funds</div>
                                <div class="link" :class="{ disabled: !companyLayout.companyAccountingAndBusinessInfo }" @click="!companyLayout.companyAccountingAndBusinessInfo ? null : openWorkModal">Petty Cash Funds</div>
                                <div class="link" :class="{ disabled: !companyLayout.companyAccountingAndBusinessInfo }" @click="!companyLayout.companyAccountingAndBusinessInfo ? null : openWorkModal">Cash Advances</div>
                                <div class="link" :class="{ disabled: !companyLayout.companyAccountingAndBusinessInfo }" @click="!companyLayout.companyAccountingAndBusinessInfo ? null : openWorkModal">Revenues</div>
                                <div class="link" :class="{ disabled: !companyLayout.companyAccountingAndBusinessInfo }" @click="!companyLayout.companyAccountingAndBusinessInfo ? null : openWorkModal">Expenditures</div>
                                <div class="link" :class="{ disabled: !companyLayout.companyAccountingAndBusinessInfo }" @click="!companyLayout.companyAccountingAndBusinessInfo ? null : routerLink('expenses')">Expenses</div>
                                <div class="link" :class="{ disabled: !companyLayout.companyAccountingAndBusinessInfo }" @click="!companyLayout.companyAccountingAndBusinessInfo ? null : openWorkModal">Accounts Payable</div>
                                <div class="link" :class="{ disabled: !companyLayout.companyAccountingAndBusinessInfo }" @click="!companyLayout.companyAccountingAndBusinessInfo ? null : routerLink('cash-advance-liquidation')">Liquidations</div>
                                <div class="link" :class="{ disabled: !companyLayout.companyAccountingAndBusinessInfo }" @click="!companyLayout.companyAccountingAndBusinessInfo ? null : openWorkModal">Asset Management</div>
                                <!-- <div class="link" :class="{ disabled: !companyLayout.companyAccountingAndBusinessInfo }" @click="!companyLayout.companyAccountingAndBusinessInfo ? null : routerLink('settings-worksheet')">Worksheet</div> -->
                            </div>
                        </el-col>
                        <el-col :span="3.4">
                            <div class="col-title">Finance</div>
                            <div class="col-content">
                                <div class="link" :class="{ disabled: !companyLayout.companyAccountingAndBusinessInfo }" @click="!companyLayout.companyAccountingAndBusinessInfo ? null : openWorkModal">Budgets</div>
                                <div class="link" :class="{ disabled: !companyLayout.companyAccountingAndBusinessInfo }" @click="!companyLayout.companyAccountingAndBusinessInfo ? null : openWorkModal">Cashflow Projections</div>
                                <div class="link" :class="{ disabled: !companyLayout.companyAccountingAndBusinessInfo }" @click="!companyLayout.companyAccountingAndBusinessInfo ? null : routerLink('finance-bank-accounts')">Bank Accounts</div>
                                <div class="link" :class="{ disabled: !companyLayout.companyAccountingAndBusinessInfo }" @click="!companyLayout.companyAccountingAndBusinessInfo ? null : openWorkModal">Cash on Hand</div>
                                <div class="link" :class="{ disabled: !companyLayout.companyAccountingAndBusinessInfo }" @click="!companyLayout.companyAccountingAndBusinessInfo ? null : openWorkModal">Credit Card Accounts</div>
                                <div class="link" :class="{ disabled: !companyLayout.companyAccountingAndBusinessInfo }" @click="!companyLayout.companyAccountingAndBusinessInfo ? null : openWorkModal">Employee Reimbursements</div>
<!--                                <div class="link" :class="{ disabled: !companyLayout.companyAccountingAndBusinessInfo }" @click="!companyLayout.companyAccountingAndBusinessInfo ? null : routerLink('finance-credit-cards-account')">Credit Cards Account</div>-->
<!--                                <div class="link" @click="routerLink('settings-credit-cards-accounts')">Credit Card Accounts</div>-->
                                <!-- <div class="link" :class="{ disabled: !companyLayout.companyAccountingAndBusinessInfo }" @click="!companyLayout.companyAccountingAndBusinessInfo ? null : openWorkModal">Revolving Funds</div> -->
                                <!-- <div class="link" :class="{ disabled: !companyLayout.companyAccountingAndBusinessInfo }" @click="!companyLayout.companyAccountingAndBusinessInfo ? null : openWorkModal">Petty Cash Funds (PCF)</div> -->
                                <!-- <div class="link" :class="{ disabled: !companyLayout.companyAccountingAndBusinessInfo }" @click="!companyLayout.companyAccountingAndBusinessInfo ? null : routerLink('cash-advances')">Cash Advances (CA)</div> -->
                                <div class="link" :class="{ disabled: !companyLayout.companyAccountingAndBusinessInfo }" @click="!companyLayout.companyAccountingAndBusinessInfo ? null : routerLink('reconciliation')">Reconciliations</div>
                                <div class="link" :class="{ disabled: !companyLayout.companyAccountingAndBusinessInfo }" @click="!companyLayout.companyAccountingAndBusinessInfo ? null : routerLink('cash-receipts')">
                                  Cash Receipts
                                </div>
                                <div class="link" :class="{ disabled: !companyLayout.companyAccountingAndBusinessInfo }" @click="!companyLayout.companyAccountingAndBusinessInfo ? null : routerLink('cash-disbursements')">
                                  Cash Disbursements
                                </div>
                                <!-- <div
                                  class="link"
                                  :class="{ disabled: !companyLayout.companyAccountingAndBusinessInfo }"
                                  @click="() => {
                                    $refs.cashDisbursementstModal.openModal()
                                    $refs.dropdown.hide()
                                  }">
                                  Cash Disbursements
                                </div> -->
                                <!-- <div class="link" :class="{ disabled: !companyLayout.companyAccountingAndBusinessInfo }" @click="!companyLayout.companyAccountingAndBusinessInfo ? null : openWorkModal">Receive Money</div> -->
                                <!-- <div class="link" :class="{ disabled: !companyLayout.companyAccountingAndBusinessInfo }" @click="!companyLayout.companyAccountingAndBusinessInfo ? null : openWorkModal">Transfer Money</div> -->
                                <!-- <div class="link" :class="{ disabled: !companyLayout.companyAccountingAndBusinessInfo }" @click="!companyLayout.companyAccountingAndBusinessInfo ? null : openWorkModal">Pay Money</div> -->
                                <div class="link" :class="{ disabled: !companyLayout.companyAccountingAndBusinessInfo }" @click="!companyLayout.companyAccountingAndBusinessInfo ? null : openWorkModal">Cash Transfers</div>
                            </div>
                        </el-col>
                    </el-row>
<!--                    <el-row type="flex" justify="end" class="actions-row">-->
<!--                        <el-button type="primary" size="mini" plain @click="routerLink('account-think')">accountTHINK (aT) DASHBOARD</el-button>-->
<!--                    </el-row>-->
                    <el-row :gutter="20">
                        <el-col :span="24" :offset="0">
                            <img src="@/assets/img/tf_l.jpg" alt="Totalflow" width="200">
                        </el-col>
                    </el-row>

                </div>
            </el-dropdown-menu>
        </el-dropdown>
        <sweet-modal title="tf Support" width="500" blocking ref="support">
            <div class="tf-support">
                <div>Sorry, this feature now under development will be ready later.</div>
            </div>
        </sweet-modal>
        <sweet-modal blocking :title="valueTitle" :subtitle="valueTime" ref="news" class="modal">
            <!-- <div class="modal__time" v-html="valueTime"></div> -->
            <!-- <h1 class="modal__title" v-html="valueTitle"></h1> -->
            <div class="modal__content" v-html="valueContent"></div>
        </sweet-modal>
<!--      <CashReceiptJournalModal ref="cashReceiptModal"/>-->
      <!-- <CashDisbursementsJournalModal ref="cashDisbursementstModal" /> -->
    </div>
</template>

<script>
    import moment from 'moment'
    import { SweetModal } from '@totalflow4/tfsweet-modal-vue'
    // import CashReceiptJournalModal from '@/layout/components/yourOrganization/CashReceiptJournalModal.vue'
    // import CashDisbursementsJournalModal from '@/layout/components/yourOrganization/CashDisbursementsJournalModal.vue'
    export default {
        name: "YourOrganizationDropDown",
        components: {
          SweetModal,
          // CashReceiptJournalModal,
        //   CashDisbursementsJournalModal,
        },
        computed: {
          newsMenu() {
              return this.$store.state.newsMenu
          },
          companyLayout() {
            return this.$store.getters.getCompanyLayout ? this.$store.getters.getCompanyLayout : {}
          },
        },
        data() {
            return {
                moment:moment,
                valueTitle: '',
                valueTime: '',
                valueContent: '',
            }
        },
        methods: {
            visibleChange(val) {
                this.toggleNavDrawer(val)
            },
            routerLink(page, query = {}) {
                this.$router.push({ name: page, query: { ...query, companyId: this.$route.query.companyId} } )
                this.$refs.dropdown.hide()
            },
            openNews(title, time, content) {
                this.valueTitle = title
                this.valueTime = `Post time: ${moment(time * 1000).format("D MMM YY, h:mm a")}`
                this.valueContent = content
                this.$refs['news'].open()
                this.$refs.dropdown.hide()
            },
            toggleNavDrawer(val) {
                this.$store.dispatch('toggleSideBar');
                if (val) {
                    this.$emit('showMenu');
                    this.$store.dispatch('getMenuStatistics');
                    this.$store.dispatch('getNewsMenu', localStorage.getItem('lang'));
                } else {
                    this.$emit('hideMenu');
                }
            },
            openWorkModal() {
                this.$refs.support.open()
                this.$refs.dropdown.hide()
            }
        }
    }
</script>

<style lang="less" scoped>
    .your-organization {
        margin-right: 10px;
        display: flex;
        align-items: center;
        background: #DFE8F0;
        color: #4277A6;
        border-radius: 3px;
        padding: 5px;
        cursor: pointer;
        white-space: nowrap;
        &:hover {
            animation: glow 800ms ease-out infinite alternate;
            background: #fff;
            border-color: #393;
            box-shadow: 0 0 7px rgba(255, 240, 160, .2), inset 0 0 7px rgba(255, 240, 160, .2);
            color: #4277A6;
            outline: none;
        }
    }
    .dropdown {
        background-color: #2a3652;
        width: 100%;
    }
    .wrapper {
        max-width: 1630px;
        margin: 0 auto;
        .el-row {
            padding: 10px;
            .col-title {
                text-transform: uppercase;
                font-size: 14px;
                color: #fff;
                text-decoration: underline;
            }
            .col-content {
                margin-top: 20px;
                display: flex;
                flex-direction: column;
                .link {
                    margin-bottom: 5px;
                    font-size: 14px;
                    cursor: pointer;
                    color: #fff !important;
                    &.disabled {
                      color: grey !important;
                    }
                    &:last-child {
                        margin-bottom: 0;
                    }
                }
            }
            /*.first-col {*/
            /*    border-right: 1px solid black;*/
            /*}*/
            /*.last-col {*/
            /*    font-size: 12px;*/
            /*    .link {*/
            /*        margin-bottom: 5px;*/
            /*        color: #fff !important;*/
            /*        cursor: pointer;*/
            /*    }*/
            /*}*/
            .actions-row {
                margin: 30px 0;
                display: flex;
                align-items: center;
                justify-content: flex-end;
            }
        }
    }
</style>

<style lang="less">
    .t-dropdown {
        left: 0 !important;
        .popper__arrow {
            display: none !important;
        }
    }
</style>
